<template>
   <div id="jobdetail"> 
         <div class="jobdetail-head">
             <div class="title">{{list.name}}</div>
              <div class="desc">
                <div class="left-desc flex align-cen">
                    <div>{{list.hiringNeeds == '社招' ? '社会' : '校园'}}招聘：</div>
                <div>{{list.jobCategory}}</div>
                 <div class="job-work"> <i class="el-icon-location"></i> {{list.workplace}}</div>
                </div>
                               <div class="left-desc flex align-cen left-desc1">
                         <div class="cen-desc flex align-cen">
                    <div>经验要求：{{list.experience}}</div>
                 <div>学历要求：{{list.degree}}</div>
                 <div>薪资范围：{{list.salaryRange}}</div>
                 <div>招聘人数：{{list.headcount}}</div>
                </div>
                <div class="right-desc mft">
                    {{list.updateTime}}发布
                </div>
                </div>
              </div>
            </div>
             <div class="job-desc">
                            <div class="job-desc-tit">
                                职位描述
                            </div>
                            <div class="job-desc-data">
                                <div v-html="list.description"></div>
                            </div>
                        </div>
                          <div class="job-desc">
                            <div class="job-desc-tit">
                                职位要求
                            </div>
                            <div class="job-desc-data">
                               <div v-html="list.requirement"></div>
                            </div>
                        </div>
                          <div class="job-btn" @click="openTd(list.id)">
                            立即投递
                        </div>
             <el-dialog
  :visible.sync="centerDialogVisible"
  width="40%"
  :append-to-body="true"
  center
  top="30vh"
  title="投递简历"
  v-if="centerDialogVisible"
  :show-close="fileId ? false : true"
  >
    <div class="formUp" >
         <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/uploadNoLogin'"
                    :on-success="handleAvatarSuccess1"
                    accept=".pdf,.doc,.docx,.ppt,.pptx,.png,.jpg,.jpeg"
                    drag
                    :file-list="fileList"
                    :on-change="handleChangePic"
                    :on-error="uploadError"
                    :before-upload="beforeUpload"
                    :show-file-list="uploadIs"
                    >
                     <i class="el-icon-upload" ></i>
                     <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                     <div slot="tip" class="el-upload__tip">支持格式：<span style="color:#f56c6c">pdf、doc、docx、ppt、pptx、png、jpg、jpeg</span></div>
                     <div slot="tip" class="el-upload__tip" v-if="resoceUrl">简历地址：<span style="color:#f56c6c">{{resoceUrl}}</span></div>
         </el-upload>
        <div class="subBtn flex align-cen" v-if="fileId">
            <div class="cancl" @click="centerDialogVisible = false">取消</div>
             <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load subTd"
          @click="uploadTd"
            >
          确定投递
           </el-button>
        </div>
    </div>
</el-dialog>
   </div>
</template>
<script>
import {jobDetail,jobResume} from "@/api/enterprise/index" // 岗位详情
import debounce from '../../../utils/debounce.js' //防抖
import goTop from '@/components/goTop'
export default {
    name:'jobHunting',
     components:{
        goTop,
    },
    data () {
        return {
            uploadIs:true,
            centerDialogVisible:false,
            loading:false,
            list:{},
             fileList:[],
            fileId:'',
            fileName:'',
            resoceUrl:'',
        }
    },
    created () {
        this.getDetail()
    },
    methods: {
             // 简历上传限制其他文件
        beforeUpload(file){
         this.uploadIs = true
        let acceptArr = [
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/pdf",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/msword",
            "application/vnd.ms-powerpoint"
            ]
            const isVideo = acceptArr.includes(file.type)

            const isLt1M = file.size / 1024 / 1024 < 500
            if (!isVideo) {
            this.uploadIs = false
             this.$util.Notifi("请上传正确的文件格式",'error','fa-exclamation-circle');
            }
            if (!isLt1M) {
            setTimeout( () => {
                 this.$util.Notifi("上传文件大小不能超过 500MB!",'error','fa-exclamation-circle');
            }, 10)
            }
            return isLt1M && isVideo
        },
        // 投递
        uploadTd(){
             this.loading = true
            let params = {
                jobId:this.$route.query.id,
                name:this.fileName,
                fileId:this.fileId
            }
               jobResume(params,'enterprise')
                .then(res => {
                     this.loading = false
                    if(res.code == 0){
                       this.$util.Notifi('投递成功','success','fa-check');
                       this.centerDialogVisible = false
                    }else{
                        this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
                })
                .catch(err => {  
                     this.loading = false                
                })
        },
        // 打开简历投递
        openTd(id){
             if(this.$route.query.type) return this.$util.Notifi('仅支持预览','error','fa-exclamation-circle');
            this.jobId = id
            this.fileList = []
            this.uploadIs = true
             this.fileId = ''
            this.fileName = ''
            this.resoceUrl = ''
            this.centerDialogVisible = true
        },
         handleAvatarSuccess1(res,file){
            this.fileId = res.data.fileId
            this.fileName = res.data.fileName
            this.resoceUrl = res.data.url
            // this.$refs.ruleForm.clearValidate('resourceUrl')
          },
        // 文件上传失败
        uploadError(){
             let errorInfo = JSON.parse(err["message"])
            this.message.error('文件上传失败，原因：' + errorInfo.message) 
        },
                 handleChangePic(file,fileList){
                        if (fileList.length > 0) {
                                        this.fileList = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的csv文件
                                    }
                    },
          // 获取详情
          getDetail(){
              jobDetail({id:this.$route.query.id},'enterprise')
                .then(res => {
                    document.title = res.data.name || '岗位详情'
                    this.list = res.data
                })
                .catch(err => {                  
                })
        },
    },
}
</script>
<style lang="scss" scoped>
#jobdetail{
    width: 80vw;
    margin: 0 auto;
    .jobdetail-head{
     display: block;
    position: relative;
    padding: 50px 30px;
    .title{
        font-size: 20px;
    font-family: "Microsoft YaHei";
    font-weight: bold;
    color: #0E0E0E;
    padding-bottom: 30px;
    }
    .desc{
        border-bottom: 1px solid #E1E1E1;
        .left-desc{
             color: #0E0E0E;
            div{
                i{
                    color: #BFBFBF;
                }
            }
            .job-work{margin-left: 20px;}
        }
        .cen-desc{
            color: #0E0E0E;
            padding: 15px 0 30px;
            div{
                 margin-right: 30px;
            }
        }
         .right-desc{
            color: #989898;
         }
    }
    }
        .job-desc{
            padding: 0 30px;
                .job-desc-tit{
                    font-size: 18px;
                    font-family: 'Microsoft YaHei';
                    font-weight: 500;
                    color: #1A1A1A;
                    position: relative;
                }
                .job-desc-tit::after{
                    content: "";
                    display: block;
                    border-top: 1px dashed #CFD9E0;
                    width: 90%;
                    position: absolute;
                    left: 100px;
                    top: 16px;
                }
                .job-desc-data{
                    padding: 20px 0;
                }
            }
               .job-btn{
                width: 150px;
                height: 32px;
                background: #2F54EB;
                border-radius: 2px;
                color: #fff;
                line-height: 32px;
                text-align: center;
                margin-top: 20px;
                cursor: pointer;
                margin-left: 30px;
                margin-bottom: 30px;
            }
}
.formUp{
    text-align: center;
    .subBtn{
        justify-content: center;
        margin-top: 30px;
        div{
       margin-right: 30px;
       width: 140px;
        height: 40px;
        border-radius: 2px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
        }
        .cancl{
            background: #F4F4F4;
            border: 1px solid #E1E1E1;
            color: #1A1A1A;
        }
        .subTd{
            color: #fff;
            background: #007EFF;
            margin-right: 30px;
       width: 140px;
        height: 40px;
        border-radius: 2px;
        text-align: center;
        cursor: pointer;
        }
    }
}
 @media (max-width: 640px){
    #jobdetail{
        margin-top: -60px;
        width: 100vw !important;
        .job-work{
            width: 100%;
            margin-left: 0 !important;
            margin: 10px 0;
        }
        .left-desc{
            flex-wrap: wrap;
        }
        .right-desc{
            width: 100%;
        }
        .cen-desc{
            flex-wrap: wrap;
            padding-bottom: 10px !important;
            div{
                width: 50%;
                margin-bottom: 10px;
            }
        }
        .job-desc-tit::after{
            display: none !important;
        }
    }
 }
::v-deep{
     @media (max-width: 640px){
           .el-dialog{
        width: 90% !important;
        .el-upload-dragger{
            width: 300px !important;
        }
     }
     }
    .el-input__inner{
        border: 1px solid #E6E6E6;
border-radius: 20px 0 0 20px;
border-right: none;
    }
 .el-input-group__append{
border: 1px solid #E6E6E6;
border-radius: 0 20px 20px 0;
background: #2F54EB;
color: #fff;
padding: 0 30px;
cursor: pointer;
 }
 .el-collapse-item__header{
   display: block;
    height: auto;
    line-height: normal;
    position: relative;
    padding: 30px;
    .el-collapse-item__arrow{
        position: absolute;
        right: 20px;
        top:50px
    }
 }
 .el-collapse-item__content{
    background: #FAFAFA;
    padding: 20px 30px;
    position: relative;
 }
}
</style>